let APILXD = {
  /**
   * 通用
   */
  //上传文件
  upLoad: '/common/upload',
  //获取七牛token
  getUploadToken: '/admin/common/getUploadToken',
  //获取所有国家(与设备无关)
  getAllCountry: '/admin/common/getCountry',
  //获取有设备的国家
  getAllCountryList: '/admin/common/getCountryList',


  /**
   * 后台账号管理
   */
  //登陆
  login: '/admin/admin/login',
  //获取密码随机串
  getRandSalt: '/admin/admin/getRandSalt',
  //后台账号列表
  getAdminList: '/admin/admin/getAdminList',
  //查询详情
  getAdminDetail: '/admin/admin/getAdminDetail',
  //退出登陆
  logoutAdmin: '/admin/admin/logoutAdmin',
  //修改密码
  modfiyPasswd: '/admin/admin/modfiyPasswd',
  //启用、禁用管理员
  enableAdmin: '/admin/admin/enableAdmin',
  //新增
  addAdmin: '/admin/admin/addAdmin',
  //编辑
  editAdmin: '/admin/admin/editAdmin',
  //删除
  delAdmin: '/admin/admin/delAdmin',
  //获取自己信息
  getMyinfo: '/admin/admin/getMyinfo',
  //授权romids
  authRomIds: '/admin/admin/authRomIds',
  //设置其他管理系统账号
  setOtherAccount: '/admin/admin/setOtherAccount',
  //删除其他管理系统账号
  removeOtherAccount: '/admin/admin/removeOtherAccount',
  //获取其他管理系统账号
  getOtherAccount: '/admin/admin/getOtherAccount',

  //公司管理
  companyIndex: '/admin/company/index',
  companySelect: '/admin/company/select',
  companyCreate: '/admin/company/create',
  companyUpdate: '/admin/company/update',
  companyDelete: '/admin/company/delete',

  //企业管理
  corporationIndex: '/platform/admin/personageAdmin/company/list',
  corporationEnable: '/platform/admin/personageAdmin/company/enable',
  corporationMemberList: '/platform/admin/personageAdmin/company/memberList',
  corporationDeviceList: '/platform/admin/personageAdmin/company/deviceList',
  corporationCapPositionList: '/platform/admin/personageAdmin/company/capPositionList',

  //用户管理
  userIndex: '/platform/admin/user/index',
  userCreate: '/platform/admin/user/create',
  userUpdate: '/platform/admin/user/update',
  userDelete: '/platform/admin/user/delete',

  //获取设备列表
  getDeviceList: "/platform/admin/device/getDeviceList",
  //获取公司列表
  getSpaceList: "/admin/space/getSpaceList",
  //系统管理员获取公司列表
  getCompanyUserList: "/admin/user/getCompanyUserList",
  //获取rom列表
  getDeviceRomIdList: "/platform/admin/device/getDeviceRomIdList",
  //设备分配公司
  assignDeviceListToSpace: "/platform/admin/device/assignDeviceToCompany",
  //获取所有公司
  getAllSpaces: "/admin/company/select",
  //获取心跳设备的所有romId
  getHeartBeatRomIds: "/admin/deviceHeartbeat/getHeartBeatRomIds",

  //设备相关
  //批量添加及分配设备
  addDeviceList: "/admin/device/addDeviceList",
  //获取设备编码数组
  getDeviceIds: "/platform/admin/device/getDeviceIds",
  //获取分身配置列表
  getShardConfList: "/admin/conf/getShardConfList",
  //获取设备动态分配配置代码
  getDeviceDynamicAssignConf: "/admin/conf/getDeviceDynamicAssignConf",
  //设置设备动态分配配置代码
  setDeviceDynamicAssignConf: "/admin/conf/setDeviceDynamicAssignConf",
  //编辑分身配置
  editShardConf: "/admin/conf/editShardConf",
  //新增分身配置
  addShardConf: "/admin/conf/addShardConf",
  //获取设备列表（分身删除）
  shardDelDeviceGetDeviceList: "/admin/shardDelDevice/getDeviceList",
  //删除设备（分身删除）
  shardDelDeviceDelDevice: "/admin/shardDelDevice/delDevice",
  //新增设备（分身删除）
  shardDelDeviceAddDevice: "/admin/shardDelDevice/addDevice",
  //获取所有配置的盒子分身
  getBoxShard: "/admin/conf/getBoxShard",

  //应用管理
  //列表
  getAppsList: "/admin/app/getAppList",
  //新增应用
  addApp: "/admin/app/addApp",
  //编辑应用
  editApp: "/admin/app/editApp",
  //删除应用
  delApp: "/admin/app/delApp",
  //获取应用更新信息-用于测试
  getApps: "/admin/app/getApps",
  //应用版本
  //获取应用版本列表
  getAppVersionList: "/admin/appVersion/getAppVersionList",
  //新增应用版本
  addAppVersion: "/admin/appVersion/addAppVersion",
  //编辑应用版本
  editAppVersion: "/admin/appVersion/editAppVersion",
  //删除应用版本
  delAppVersion: "/admin/appVersion/delAppVersion",
  //设置应用版本状态
  setAppVersionStatus: "/admin/appVersion/setAppVersionStatus",
  //ipfs白名单
  ipfsGetDeviceList: "/admin/appIpfs/getDeviceList",
  //ipfs白名单
  ipfsDelDevice: "/admin/appIpfs/delDevice",
  //ipfs白名单
  ipfsAddDevice: "/admin/appIpfs/addDevice",

  //系统错误
  //获取系统日志列表
  getSyslogList: '/admin/syslog/getSyslogList',
  //删除系统日志
  delSyslog: '/admin/syslog/delSyslogs',

  //系统配置
  getAllGlobalConfigs: "/admin/globalConfig/getAllGlobalConfigs",
  setGlobalConfigs: "/admin/globalConfig/setGlobalConfigs",
  getPlanDistribLimit: "/admin/plan/getPlanDistribLimit",
  setPlanDistribLimit: "/admin/plan/setPlanDistribLimit",

  //获取设备实时总在线离线数
  getDeviceTotal: "/admin/deviceHeartbeat/getDeviceTotal",
  //获取设备每月在线达标数
  getDeviceMonthStandard: "/admin/deviceHeartbeat/getDeviceMonthStandard",
  //获取设备每日损耗情况
  getDeviceDayLoss: "/admin/deviceHeartbeat/getDeviceDayLoss",
  //获取最近30天新增设备
  getLatestThirtyAddDevice: "/admin/deviceHeartbeat/getLatestThirtyAddDevice",
  //获取超过30天未上线设备
  getOfflineThirtyDevice: "/admin/deviceHeartbeat/getOfflineThirtyDevice",
  //获取超过30天未上线设备
  getOnOfflineDeviceRate: "/admin/deviceHeartbeat/getOnOfflineDeviceRate",
  //获取当前设备位置分布
  getDeviceLocation: "/admin/deviceHeartbeat/getDeviceLocation",
  //获取设备列表
  getHeartbeatDeviceList: "/admin/deviceHeartbeat/getHeartbeatDeviceList",
  //获取设备详情
  getDevice: "/admin/deviceHeartbeat/getDevice",
  //获取设备几号到几号的每日在线时长
  getDeviceDayOnline: "/admin/deviceHeartbeat/getDeviceDayOnline",
  //获取设备某一天的心跳记录
  getDeviceDayHeartbeat: "/admin/deviceHeartbeat/getDeviceDayHeartbeat",
  //获取历史每天新增设备
  getLatestAllAddDevice: "/admin/deviceHeartbeat/getLatestAllAddDevice",
  //获取历史每天设备在线比
  getOnOfflineAllDeviceRate: "/admin/deviceHeartbeat/getOnOfflineAllDeviceRate",
  //导出设备
  exportHeartbeatDeviceList: "/admin/deviceHeartbeat/exportHeartbeatDeviceList",
  //获取设备区域分布数量统计
  getDeviceAreaTotalMsg: "/admin/deviceHeartbeat/getCountryDevice",
  //设备剩余空间
  getDeviceFreeSize: "/admin/deviceHeartbeat/getDeviceFreeSize",

  //内置查询配置
  addBuiltInQuery: "/admin/chartBuiltInQuery/addBuiltInQuery",
  //编辑内置查询
  editBuiltInQuery: "/admin/chartBuiltInQuery/editBuiltInQuery",
  //删除内置查询
  delBuiltInQuery: "/admin/chartBuiltInQuery/delBuiltInQuery",
  //获取内置查询列表
  getBuiltInQueryList: "/admin/chartBuiltInQuery/getBuiltInQueryList",
  //设置内置查询排序
  setBuiltInQuerySort: "/admin/chartBuiltInQuery/setBuiltInQuerySort",
  //获取内置查询详情
  getBuiltInQuery: "/admin/chartBuiltInQuery/getBuiltInQuery",

  //ESIM管理
  //查询短信列表
  esimGetMessageList: "/platform/admin/getMessageList",
  //新增 esim
  esimInsert: "/platform/admin/insert",
  //修改 Esim 过期时间
  esimUpdate: "/platform/admin/update",
  //回收 Esim
  esimRecycle: "/platform/admin/recycleEsim",
  //查询esim列表
  esimGetESIMList: "/platform/admin/getESIMList",
  //查询esim黑明单
  esimGetESIMBlackList: '/platform/admin/esimBlackList',
  //添加黑名单
  esimAddBlackList: '/platform/admin/esimBlackAdd',
  //删除黑名单
  esimDelBlackList: '/platform/admin/esimBlackDel',
  //发送验证码
  esimSendTestMessage: "/platform/admin/sendTestMessage",
  //获取平台下拉数据
  getPlatformList: "/platform/admin/getPlatformList",
  //统计
  esimDeviceStatistics: "/platform/admin/deviceStatistics",
  //手动绑定
  esimPreBind: "/platform/admin/preBind",
  //回收站
  //获取回收站列表
  esimGetRecycleEsimList: "/platform/admin/getRecycleEsimList",
  //Esim 还原
  esimRestore: "/platform/admin/restoreESim",
  //获取ESIM分类
  getDistinctClassify: "/platform/admin/getDistinctClassify",

  // 独享ESIM管理

  //查询esim列表
  esimGetPirvateESIMList: "/platform/admin/exclusive/getESIMList",
  // 新增 独享 esim
  esimPrivateInsert: "/platform/admin/exclusive/insert",
  //修改 Esim 过期时间
  esimPrivateUpdate: "/platform/admin/exclusive/update",
  // 独享ESIM 手动绑定
  esimPrivatePreBind: "/platform/admin/exclusive/preBind",
  //回收 Esim
  esimPrivateRecycle: "/platform/admin/exclusive/recycleEsim",
  // 独享ESIM统计
  esimPrivateDeviceStatistics: "/platform/admin/exclusive/deviceStatistics",

  esimPrivateRestore: "/platform/admin/exclusive/restoreESim",


  //终端管理
  //新增分类
  insertClassification: "/platform/admin/terminal/insertClassification",
  //查询分类列表
  getClassificationList: "/platform/admin/terminal/getClassificationList",
  //删除分类
  deleteClassification: "/platform/admin/terminal/deleteClassification",
  //编辑分类
  updateClassification: "/platform/admin/terminal/updateClassification",
  //新增规则
  insertRule: "/platform/admin/terminal/insertRule",
  //编辑规则
  updateRule: "/platform/admin/terminal/updateRule",
  //删除规则
  deleteRule: "/platform/admin/terminal/deleteRule",
  //查询规则列表
  getRuleList: "/platform/admin/terminal/getRuleList",
  //ROM列表
  ruleRomList: "/platform/admin/terminal/ruleRomList",
  //更新
  renewal: "/platform/admin/terminal/renewal",
  //分类检索下拉框
  classificationSearch: "/platform/admin/terminal/classificationSearch",


  //仪表盘主题相关
  //获取主题列表
  getThemeList: "/platform/admin/chartTheme/getChartThemeList",
  //获取主题详情
  getThemeDetail: "/platform/admin/chartTheme/getChartTheme",
  //新增主题
  addTheme: "/platform/admin/chartTheme/addChartTheme",
  //编辑主题
  editTheme: "/platform/admin/chartTheme/editChartTheme",
  //删除主题
  delTheme: "/platform/admin/chartTheme/delChartTheme",
  //设置主题状态
  setThemeStatus: "/platform/admin/chartTheme/setChartThemeStatus",
  //设置主题排序
  setThemeSort: "/platform/admin/chartTheme/setChartThemeSort",

  //模板管理
  //设置模板排序
  setDashboardModelSort: "/platform/admin/dashBoardModel/setDashboardModelSort",
  //新增仪表板模板
  addDashBoardModel: "/platform/admin/dashBoardModel/addDashBoardModel",
  //编辑仪表板模板
  editDashboardModel: "/platform/admin/dashBoardModel/editDashboardModel",
  //更新仪表板模板封面图
  updateDashboardModelImg: "/platform/admin/dashBoardModel/updateDashboardModelImg",
  //删除仪表板模板
  delDashboardModel: "/platform/admin/dashBoardModel/delDashboardModel",
  //更新仪表板模板数据
  updateDashboardModel: "/platform/admin/dashBoardModel/updateDashboardModel",
  //获取仪表板模板详情
  getDashboardModelDetail: "/platform/admin/dashBoardModel/getDashboardModelDetail",
  //复制模版
  copyDashboard: "/platform/admin/dashBoardModel/copyDashboard",
  //获取仪表板模板历史列表
  getDashboardModelHistoryList: "/platform/admin/dashBoardModel/getDashboardModelHistoryList",
  //获取仪表板历史详情
  getDashboardHistory: "/platform/admin/dashBoardModel/getDashboardHistory",
  //获取仪表板模板列表 后台
  getDashboardModelList: "/platform/admin/dashBoardModel/getDashboardModelList",
  //获取所有主题
  getChartThemeListAll: "/platform/admin/chartTheme/getChartThemeListAll",

  //自定义组件管理
  //获取分类和组件列表
  getModuleCategoryAndModuleList: "/platform/admin/module/getModuleCategoryAndModuleList",
  //自定义 db 语句查询接口
  executeDbQuery: "/platform/admin/module/executeDbQuery",
  //编辑/新增自定义组件
  editOrAddCustomModule: "/platform/admin/module/editOrAddCustomModule",
  //编辑或者新增组件类别
  editOrAddModuleCategory: "/platform/admin/module/editOrAddModuleCategory",
  //获取自定义组件详情
  getCustomModuleDetail: "/platform/admin/module/getCustomModuleDetail",
  //获取所有的自定义组件
  getCustomModuleList: "/platform/admin/module/getCustomModuleList",
  //删除自定以组件
  delCustomModule: "/platform/admin/module/delCustomModule",
  //获取后台组件类别
  getBackStageCategory: "/platform/admin/module/getBackStageCategory",
  //删除组件类别
  delModuleCategory: "/platform/admin/module/delModuleCategory",

  //业务设备统计
  businessGetSpaceList: "/platform/admin/device/statistics/getSpaceList",
  businessGetDeviceList: "/platform/admin/device/statistics/getDeviceList",
  businessCountryStatistics: "/platform/admin/device/statistics/countryStatistics",
  businessSpaceStatistics: "/platform/admin/device/statistics/spaceStatistics",
  businessIPStatistics: "/platform/admin/device/statistics/ipStatistics",
  businessMobileStatistics: "/platform/admin/device/statistics/mobileStatistics",

  //设备状态统计
  getDeviceCenter: "/admin/device/getDeviceCenter",
  getDeviceScript: "/admin/device/getDeviceScript",
  getDeviceRemote: "/admin/device/getDeviceRemote",
  getDeviceTop20: "/admin/device/getDeviceTop20",
  getDeviceRom: "/admin/device/getDeviceRom",
  getDeviceFreeSizeTwo: "/admin/device/getDeviceFreeSize",
  getDeviceByCondList: "/admin/device/getDeviceByCondList",
  exportDeviceByCond: "/admin/device/exportDeviceByCond",

  //商业运营管理
  //会员
  vipList: '/platform/admin/vip/vipList',
  devVipList: '/platform/admin/vip/devVipList',
  editVip: '/platform/admin/vip/editVip',
  editDevVip: '/platform/admin/vip/editDevVip',

  //套餐
  pricePackageGetList: '/platform/admin/pricePackage/getList',
  pricePackageTargetTag: '/platform/admin/pricePackage/targetTag',
  pricePackageAdd: '/platform/admin/pricePackage/add',
  pricePackageEdit: '/platform/admin/pricePackage/edit',
  pricePackageDel: '/platform/admin/pricePackage/del',
  pricePackageDisable: '/platform/admin/pricePackage/disable',

  //企业会员
  enterprisePriceGetList: '/platform/admin/companySeat/getSeatPackageList',
  enterpriseSeatDetail: '/platform/admin/companySeat/getSeatPackageDetail',
  enterprisePriceAdd: '/platform/admin/companySeat/saveSeatPackage',
  enterprisePriceSet: '/platform/admin/companySeat/setSeatPackageStatus',
  enterprisePriceDel: '/platform/admin/companySeat/deleteSeatPackage',
  
  //商品推荐管理
  getPersonageCapList: '/platform/admin/personageAdmin/getPersonageCapList',
  setPersonageCapSystemTag: '/platform/admin/personageAdmin/setPersonageCapSystemTag',
  getPersonagePositionList: '/platform/admin/personageAdmin/getPersonagePositionList',
  setPersonagePositionSystemTag: '/platform/admin/personageAdmin/setPersonagePositionSystemTag',
  getPersonageCapSimplifiedList: '/platform/admin/personageAdmin/getPersonageCapSimplifiedList',
  getPersonagePositionSimplifiedList: '/platform/admin/personageAdmin/getPersonagePositionSimplifiedList',

  //官网内容配置
  addConfComment: '/platform/admin/personageAdmin/addConfComment',
  getConfCommentList: '/platform/admin/personageAdmin/getConfCommentList',
  updateConfComment: '/platform/admin/personageAdmin/updateConfComment',
  delConfComment: '/platform/admin/personageAdmin/delConfComment',
  updateConfCommentStatus: '/platform/admin/personageAdmin/updateConfCommentStatus',
  addConfBuyStats: '/platform/admin/personageAdmin/addConfBuyStats',
  getConfBuyStatsList: '/platform/admin/personageAdmin/getConfBuyStatsList',
  updateConfBuyStats: '/platform/admin/personageAdmin/updateConfBuyStats',
  delConfBuyStats: '/platform/admin/personageAdmin/delConfBuyStats',
  updateConfBuyStatsStatus: '/platform/admin/personageAdmin/updateConfBuyStatsStatus',

  //协议部分
  createAgreement: '/platform/admin/agreement/createAgreement',
  createAgreementGroup: '/platform/admin/agreement/createAgreementGroup',
  editAgreementGroup: '/platform/admin/agreement/editAgreementGroup',
  delAgreementGroup: '/platform/admin/agreement/delAgreementGroup',
  editAgreement: '/platform/admin/agreement/editAgreement',
  editAgreementSort: '/platform/admin/agreement/editAgreementSort',
  delAgreement: '/platform/admin/agreement/delAgreement',
  getAgreementGroupList: '/platform/admin/agreement/getAgreementGroupList',
  getAgreementList: '/platform/admin/agreement/getAgreementList',
  agreementDisable: '/platform/admin/agreement/disable',

  //工单部分
  getWorkOrderList: '/platform/admin/personageAdmin/getWorkOrderList',
  updateWorkOrderStatus: '/platform/admin/personageAdmin/updateWorkOrderStatus',

  //提现
  getMagicPowerWithdrawList: '/platform/admin/personageAdmin/getMagicPowerWithdrawList',
  magicPowerWithdraw: '/platform/admin/personageAdmin/MagicPowerWithdraw',

  //举报
  getReportList: '/platform/admin/review/getReviewList',
  ignoreReport: '/platform/admin/review/ignoreReview',
  offReport: '/platform/admin/review/offReview',
  delReportComment: '/platform/admin/review/delComment',

  //模型管理
  getAiModelList: '/platform/admin/aiModel/aiModeGroupList',
  addAiModelGroup: '/platform/admin/aiModel/addAiModelGroup',
  editAiModelGroup: "/platform/admin/aiModel/editAiModelGroup",
  enableAiModelStatus: "/platform/admin/aiModel/enableStatus",
  delAiModelGroup: "/platform/admin/aiModel/deleteAiModelGroup",
  modelKeysList: "/platform/admin/aiModel/modelKeysList",
  modelAddKey: "/platform/admin/aiModel/addKey",
  modelEditKey: "/platform/admin/aiModel/editKey",
  modelDeleteKey: '/platform/admin/aiModel/deleteKey',
  modelGetKeyList: "/platform/admin/aiModel/getKeyList",
  modelAddKeyEntity: "/platform/admin/aiModel/addKeyEntity",
  modelEditKeyEntity: "/platform/admin/aiModel/editKeyEntity",
  modelDelKeyEntity: "/platform/admin/aiModel/delKeyEntity",
};

module.exports = APILXD;
